import * as React from 'react'

import { PlusUserListenerContext, TPlusUserListener } from './context'

export const withPlusUserListenerProvider = Component => props => {
  const [plusUserListener, setPlusUserListener] = React.useState<
    TPlusUserListener
  >(null)

  return (
    <PlusUserListenerContext.Provider
      value={{
        plusUserListener,
        setPlusUserListener
      }}
    >
      <Component {...props} />
    </PlusUserListenerContext.Provider>
  )
}



// WEBPACK FOOTER //
// ./src/components/PlusUserListener/withPlusUserListenerProvider.tsx